import { Injectable } from '@angular/core';
import { HttpClient } from '../_services/global-http.service';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';

import { VehicleAdminRow, AdminVehiclePaginationApi, IPaginatedVehicleResponse, SimpleVehicleFmt, IPaginatedSimpleVehicleResponse, IVehiclePaginationResponse } from '../_models/vehicle';
import { IDangoPaginationParams, IVORDashboardPaginationParams, PaginationParams } from '../_models/generic';
import { Utilities } from '../_utilities/Utilities';

@Injectable()
export class VehiclesService {
  data: any;
  adminVehicleData: AdminVehiclePaginationApi;

  constructor(private http: HttpClient) { }


  findAdminVehicles(params: PaginationParams): Observable<AdminVehiclePaginationApi> {
    const _params = Utilities.convertPaginationParameters(params);
    return this.http.get<AdminVehiclePaginationApi>('/api/administration/vehicles/', { params: _params });
  }


  getVehicles() {
    this.data = this.http.get('/api/vehicles/');
    return this.data;
  }

  getAdminVehicles() {
    this.data = this.http.get('/api/administration/vehicles/');
    return this.data;
  }

  // A api for getting a list of vehicles for the view-vehicle-groups edit page. 
  // For the vehicles drop down
  // getAdminCustomerVehicles(params: PaginationParams) {
  //   return this.data = this.http.get('/api/administration/customer_vehicles/', {params: params});
  // }
  getAdminCustomerVehicles(params: PaginationParams): Observable<AdminVehiclePaginationApi> {
    const _params = Utilities.convertPaginationParameters(params);
    return this.http.get<AdminVehiclePaginationApi>('/api/administration/vehicles/', { params: _params });
  }

  getVehiclesManufacturers() {
    this.data = this.http.get('/api/vehicle_manufacturers/');
    return this.data;
  }

  getVehiclesManModels() {
    this.data = this.http.get('/api/vehicle_man_models/');
    return this.data;
  }

  public getVehicleLiveryCategories() {
    this.data = this.http.get('/api/livery_category/');
    return this.data;
  }

  public getDriverCategories() {
    this.data = this.http.get('/api/administration/driver_category/');
    return this.data;
  }

  public getVehicleContractTypes() {
    this.data = this.http.get('/api/administration/vehicle_contract_type/');
    return this.data;
  }

  public getLeaseCompanies() {
    this.data = this.http.get('/api/administration/lease_companies/');
    return this.data;
  }

  getVehicle(id: number) {
    this.data = this.http.get('/api/vehicle/' + id + '/');
    return this.data;
  }

  // used for getting the vehicle groups for a vehicle
  getVehicleAssignedGroups(id: number) {
    this.data = this.http.get('/api/vehicle/' + id + '/vehicle_groups');
    return this.data;
  }

  getVehiclesGroupList() {
    this.data = this.http.get('/api/vehicles_group_list/');
    return this.data;
  }

  getVehiclesGroupsListSmall(params: PaginationParams) {
    this.data = this.http.get('/api/vehicles_group_list_small/', { params: params });
    return this.data;
  }

  postAddVehicle(newVehicle: any) {
    let apiAddNewVehicle = '/api/vehicles/';
    this.data = this.http.post(apiAddNewVehicle, newVehicle);
    return this.data;
  }

  removeVehicle(id: any) {
    this.data = this.http.post('/api/vehicles_delete/', id);
    return this.data;
  }

  putUpdateVehicle(updateVehicle: any, id: number) {
    let apiUpdateVehicle = '/api/vehicle/' + id + '/';
    this.data = this.http.put(apiUpdateVehicle, updateVehicle);
    return this.data;
  }

  getVehiclesTrackers() {
    this.data = this.http.get('/api/vehicles_trackers/');
    return this.data;
  }

  getCurrentCustomers() {
    this.data = this.http.get('/api/customers/get_current_customer/');
    return this.data;
  }

  getActiveDevices() {
    this.data = this.http.get('/api/active_devices/');
    return this.data;
  }

  getVehicleLive(vehicleID: number, duration: number = 5) {
    this.data = this.http.get(`/api/latest_vehicle_video/${vehicleID}/?Storage=All&SubSamplingInterval=1`, undefined, undefined, undefined, undefined, true);
    return this.data;
  }

  getVehicleLiveVideoSource(url: string) {
    return this.http.get(url).toPromise();
  }

  getVehicleLiveSnapshotJpg(vehicleID: number) {
    this.data = this.http.get(`/api/live_vehicle_snapshots/${vehicleID}/`);
    return this.data;
  }
  getVehiclesPaginatedV2(params: PaginationParams, search): Observable<IPaginatedVehicleResponse> {
    if (search) {
      params.search = search;
    }
    return this.http.get<IPaginatedVehicleResponse>('/api/fmt/paginated_vehicles_v2/', { params: params });
  }

  getSimpleVehicleList(params: PaginationParams, search): Observable<IPaginatedSimpleVehicleResponse> {
    if (search) {
      params.search = search;
    }
    return this.http.get<IPaginatedVehicleResponse>('/api/fmt/simple_vehicle_list/', { params: params });
  }

  getVORVehicles(params: IVORDashboardPaginationParams): Observable<IVehiclePaginationResponse> {
    Object.keys(params).forEach((key) => (params[key] == null) && delete params[key]);
    let _qs = Object.keys(params).map(key => key + '=' + params[key]).join('&');
    return this.http.get<IVehiclePaginationResponse>(`/api/vor_list/?${_qs}`);
  }


}




// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/_services/vehicles.service.ts